<template>
<div class="row_">
 
 <!--TABLE GRID -->
 <div class="table-wrapper-scroll-y my-custom-scrollbar">
  <table  id='my-table' class="table table-hover table-bordered  table-sm table-striped mb-0">
    <thead>
      <tr>
        <th v-for="col in visibleColumns" :key="col.key"
          :class="{ 'text-right': col.format > 0 }"
        >
          {{ col.label }}
        </th>
      </tr>
    </thead>

    <tbody>
      <tr 
      :style="rowStyle(row)"
       
      v-for="(row, rowIndex) in rows" :key="rowIndex">
        <td 
          v-for="(col,colIndex) in visibleColumns"
          :key   ="col.key"
          :style ="colStyle(row[col.key],col)"
          :class ="{ 'text-right': col.format > 0 }"
        >

        <span v-if="colIndex === 0">
        <i
          v-if="iconaRiga(row)"
          :class="iconaRiga(row)"
        ></i>
        </span>

        {{ formatValue(row[col.key], col) }}
         
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr v-for="(row, rowIndex) in row_total" :key="rowIndex">
        <td
          v-for="col in visibleColumns"
          :key="col.key"
          :class="{ 'text-right': col.format > 0 }"
        >
        {{ formatValue(row[col.key], col) }}
         
        </td>
      </tr>
    </tfoot>
  </table>

 </div>
<!-- TABLE GRID -->
<div v-if="false">
      <h5 v-if="false" class="mb-4">Dati JSON:</h5>
      <pre>{{visibleColumns}}</pre> 
      
    </div>

</div> 
</template>

<script>

import fmt               from '@/components/mixins/fmt'
export default {
   props      : ['cols','rows','row_total','reportId'],
   mixins     : [fmt],
   components: {
  
   
  },
  data () {
    return { 
     
    }
  },
  computed: 
  {   
    
        visibleColumns() {
            
            
            return this.cols.filter(
                col => col.visible === true || col.visible === undefined
            )
                
        },

        filteredColumns() {
            return this.cols.filter(col => col.filter === true);
    },

       
  },


  created()
  { 
     

  },
      
  mounted()
  {},
  methods: 
  {

    iconaRiga(row) {
    if (row.qtaVenduta === 0) {
      return 'fa fa-exclamation-triangle text-danger  mr-1';
    }

    return row.utile > 0
      ? 'fas fa-euro-sign text-success mr-1'
      : 'fas fa-euro-sign text-danger mr-1';
    },
    

    rowStyle(item) {
    if(item.groupingId == 2  && this.reportId == 1)
    {
        return{
          color      : 'black',
          
          fontSize   : '18px'  
        }
        
    }
    if(item.groupingId == 1 )
    {
        return{
          color      : 'black',          
          fontSize   : '16px'  
        }
        
    }
    if(item.groupingId == 2  && this.reportId == 2)
    {
        return{
          color      : 'blue',
          fontWeight : 'bold',
          fontSize   : '18px'  
        }
        
    }
    
    },

    colStyle(value,column)
    {
      if(column.key == 'qtaVenduta' && value == 0)
      {
        return {'color':'red',fontWeight : 'bold',}
      }
    },
    formatValue(value, column) {    
    switch (column.format) {
      case 1:
        return this.fmt1(value)
        

      case 2:

        return this.fmt2(value)

      case 3:

        return this.fmt3(value)
        
      case 0:
        return ''
      default:
        return value
    }
  }
  }
  
}
</script>

<style scoped>


.my-custom-scrollbar {
position   : relative;
height     : 700px;
overflow   : auto;
}
.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }
 /* tutti gli header */
.table thead th {
 
  color       : rgb(16, 16, 15) !important;
  background  : #a9cbe2 !important;

}

 .table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-size    : 22px;
    background   : rgb(222, 215, 215);
    
    font-weight  : bold;
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }

 .table-wrapper-scroll-y {
  display: block;
}

.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}

.table {
  border-collapse: separate;
}



</style>